import PropTypes from 'prop-types';
import React from 'react';

import styles from './index.scss';

const ProgressCircle = ({ percentage, strokeWidth, style, trailStyle, pathStyle, textStyle }) => {
  const radius = (50 - (strokeWidth / 2));
  const diameter = Math.PI * 2 * radius;
  const pathDescription = `
      M 50,50 m 0,-${radius}
      a ${radius},${radius} 0 1 1 0,${2 * radius}
      a ${radius},${radius} 0 1 1 0,-${2 * radius}
    `;
  return (
    <svg
      className={styles.container}
      style={style}
      viewBox='0 0 100 100'
    >
      <path
        className={styles.trail}
        d={pathDescription}
        strokeWidth={strokeWidth}
        style={trailStyle}
      />
      <path
        className={styles.path}
        d={pathDescription}
        strokeWidth={strokeWidth}
        style={{
          ...pathStyle,
          strokeDasharray: `${diameter}px ${diameter}px`,
          strokeDashoffset: `${(((100 - percentage) / 100) * diameter)}px`,
        }}
      />
      <text
        className={styles.text}
        x={50}
        y={50}
        style={textStyle}
      >
        {percentage}%
      </text>
    </svg>
  );
};

ProgressCircle.propTypes = {
  pathStyle: PropTypes.object,
  percentage: PropTypes.number.isRequired,
  style: PropTypes.object,
  strokeWidth: PropTypes.number,
  textStyle: PropTypes.object,
  trailStyle: PropTypes.object,
};
ProgressCircle.defaultProps = {
  strokeWidth: 8,
};

export default ProgressCircle;
